import React, { useContext } from "react";
import { StaticImage } from "gatsby-plugin-image";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import PropTypes from "prop-types";
import {
  Accordion,
  Card,
  useAccordionButton,
  AccordionContext,
} from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ContextAwareToggle({ children, eventKey, callback }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <button
      className={isCurrentEventKey ? "card-header active" : "card-header"}
      type="button"
      onClick={decoratedOnClick}
    >
      {children}{" "}
      <span className="accordionArrow">
        {isCurrentEventKey ? (
          <i className="fa fa-angle-up" />
        ) : (
          <i className="fa fa-angle-down" />
        )}
      </span>
    </button>
  );
}

const TabsBlock = () => {
  const Tabsettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };
  return (
    <>
      <div className="row justify-content-center pb-2">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div id="accord">
            <Accordion defaultActiveKey="0">
              <Card>
                <ContextAwareToggle as={Card.Header} eventKey="0">
                  Specialist Consultation
                </ContextAwareToggle>
                <Accordion.Collapse eventKey="0">
                  <div className="row p-4 justify-content-center">
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7065.png"
                          alt="Gynaecology"
                        />
                        <p className="pt-2">
                          <b>Gynaecology</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7167.png"
                          alt="ENT"
                        />
                        <p className="pt-2">
                          <b>ENT</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7168.png"
                          alt="Orthopaedics"
                        />
                        <p className="pt-2">
                          <b>Orthopaedics</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7169.png"
                          alt="Cardiology"
                        />
                        <p className="pt-2">
                          <b>Cardiology</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7170.png"
                          alt="Dietetics"
                        />
                        <p className="pt-2">
                          <b>Dietetics</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7171.png"
                          alt="Master Health Check-ups"
                        />
                        <p className="pt-2">
                          <b>Master Health Check-ups</b>
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                      <div className="SpecialistTab">
                        <StaticImage
                          src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7172.png"
                          alt="Immunization for children, adults"
                        />
                        <p className="pt-2">
                          <b>Immunization for children, adults</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </Accordion.Collapse>
              </Card>

              <Card>
                <ContextAwareToggle as={Card.Header} eventKey="1">
                  Treatments
                </ContextAwareToggle>
                <Accordion.Collapse eventKey="1">
                  <Slider {...Tabsettings}>
                    <div className="tabs-padding">
                      <div className="row p-0 justify-content-center">
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7205.png"
                              alt="Diabetes"
                            />
                            <p className="pt-2">
                              <b>Diabetes</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7206.png"
                              alt="Hypertension"
                            />
                            <p className="pt-2">
                              <b>Hypertension</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7207.png"
                              alt="Thyroid Disorders"
                            />
                            <p className="pt-2">
                              <b>Thyroid Disorders</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7208.png"
                              alt="Asthma"
                            />
                            <p className="pt-2">
                              <b>Asthma</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7209.png"
                              alt="COPD"
                            />
                            <p className="pt-2">
                              <b>COPD</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7210.png"
                              alt="Anxiety Disorders"
                            />
                            <p className="pt-2">
                              <b>Anxiety Disorders</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7211.png"
                              alt="Sleep Disorders"
                            />
                            <p className="pt-2">
                              <b>Sleep Disorders</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7226.png"
                              alt="CAD"
                            />
                            <p className="pt-2">
                              <b>CAD</b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tabs-padding">
                      <div className="row p-0 justify-content-center">
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7225.png"
                              alt="Migraine"
                            />
                            <p className="pt-2">
                              <b>Migraine</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7224.png"
                              alt="Sinusitis"
                            />
                            <p className="pt-2">
                              <b>Sinusitis</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7223.png"
                              alt="Epilepsy"
                            />
                            <p className="pt-2">
                              <b>Epilepsy</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7222.png"
                              alt="Depression"
                            />
                            <p className="pt-2">
                              <b>Depression</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7221.png"
                              alt="Dengue, Malaria &amp; <br/> Typhoid"
                            />
                            <p className="pt-2">
                              <b>
                                Dengue, Malaria &amp; <br /> Typhoid
                              </b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Treatments/Group7220.png"
                              alt="Pneumonia"
                            />
                            <p className="pt-2">
                              <b>Pneumonia</b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </Accordion.Collapse>
              </Card>
              <Card>
                <ContextAwareToggle as={Card.Header} eventKey="2">
                  Emergency Services
                </ContextAwareToggle>
                <Accordion.Collapse eventKey="2">
                  <Slider {...Tabsettings}>
                    <div className="tabs-padding">
                      <div className="row p-0 justify-content-center">
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7195.png"
                              alt="Acute Pulmonary Edema"
                            />
                            <p className="pt-2">
                              <b>Acute Pulmonary Edema</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7196.png"
                              alt="Accelerated Hypertension"
                            />
                            <p className="pt-2">
                              <b>Accelerated Hypertension</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7197.png"
                              alt="Trauma"
                            />
                            <p className="pt-2">
                              <b>Trauma</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7198.png"
                              alt="Respiratory Failure"
                            />
                            <p className="pt-2">
                              <b>Respiratory Failure</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7199.png"
                              alt="Acute Abdomen"
                            />
                            <p className="pt-2">
                              <b>Acute Abdomen</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7204.png"
                              alt="Myocardial Infarction"
                            />
                            <p className="pt-2">
                              <b>Myocardial Infarction</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7203.png"
                              alt="Poisonings"
                            />
                            <p className="pt-2">
                              <b>Poisonings</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7202.png"
                              alt="Sepsis"
                            />
                            <p className="pt-2">
                              <b>Sepsis</b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tabs-padding">
                      <div className="row p-0 justify-content-center">
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7201.png"
                              alt="Stroke"
                            />
                            <p className="pt-2">
                              <b>Stroke</b>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                          <div className="SpecialistTab">
                            <StaticImage
                              src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7200.png"
                              alt="Anaphylaxis"
                            />
                            <p className="pt-2">
                              <b>Anaphylaxis</b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
          <div id="tab-block">
            <Tabs
              defaultActiveKey="Specialist_Consultation"
              transition={false}
              id="tabs"
            >
              <Tab
                eventKey="Specialist_Consultation"
                title="Specialist Consultation"
              >
                <div className="row justify-content-center">
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7065.png"
                        alt="Gynaecology"
                      />
                      <p className="pt-2">
                        <b>Gynaecology</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7167.png"
                        alt="ENT"
                      />
                      <p className="pt-2">
                        <b>ENT</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7168.png"
                        alt="Orthopaedics"
                      />
                      <p className="pt-2">
                        <b>Orthopaedics</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7169.png"
                        alt="Cardiology"
                      />
                      <p className="pt-2">
                        <b>Cardiology</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7170.png"
                        alt="Dietetics"
                      />
                      <p className="pt-2">
                        <b>Dietetics</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7171.png"
                        alt="Master Health Check-ups"
                      />
                      <p className="pt-2">
                        <b>Master Health Check-ups</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                    <div className="SpecialistTab">
                      <StaticImage
                        src="../../../assets/images/kmc-images/Tabs/Specialist_Consultation/Group7172.png"
                        alt="Immunization for children, adults"
                      />
                      <p className="pt-2">
                        <b>Immunization for children, adults</b>
                      </p>
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab eventKey="Treatments" title="Treatments">
                <Slider {...Tabsettings}>
                  <div className="tabs-padding">
                    <div className="row p-0 justify-content-center">
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7205.png"
                            alt="Diabetes"
                          />
                          <p className="pt-2">
                            <b>Diabetes</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7206.png"
                            alt="Hypertension"
                          />
                          <p className="pt-2">
                            <b>Hypertension</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7207.png"
                            alt="Thyroid Disorders"
                          />
                          <p className="pt-2">
                            <b>Thyroid Disorders</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7208.png"
                            alt="Asthma"
                          />
                          <p className="pt-2">
                            <b>Asthma</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7209.png"
                            alt="COPD"
                          />
                          <p className="pt-2">
                            <b>COPD</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7210.png"
                            alt="Anxiety Disorders"
                          />
                          <p className="pt-2">
                            <b>Anxiety Disorders</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7211.png"
                            alt="Sleep Disorders"
                          />
                          <p className="pt-2">
                            <b>Sleep Disorders</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7226.png"
                            alt="CAD"
                          />
                          <p className="pt-2">
                            <b>CAD</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tabs-padding">
                    <div className="row p-0 justify-content-center">
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7225.png"
                            alt="Migraine"
                          />
                          <p className="pt-2">
                            <b>Migraine</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7224.png"
                            alt="Sinusitis"
                          />
                          <p className="pt-2">
                            <b>Sinusitis</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7223.png"
                            alt="Epilepsy"
                          />
                          <p className="pt-2">
                            <b>Epilepsy</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7222.png"
                            alt="Depression"
                          />
                          <p className="pt-2">
                            <b>Depression</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7221.png"
                            alt="Dengue, Malaria &amp; <br/> Typhoid"
                          />
                          <p className="pt-2">
                            <b>
                              Dengue, Malaria &amp; <br /> Typhoid
                            </b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Treatments/Group7220.png"
                            alt="Pneumonia"
                          />
                          <p className="pt-2">
                            <b>Pneumonia</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </Tab>
              <Tab eventKey="Emergency_Services" title="Emergency Services">
                <Slider {...Tabsettings}>
                  <div className="tabs-padding">
                    <div className="row p-0 justify-content-center">
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7195.png"
                            alt="Acute Pulmonary Edema"
                          />
                          <p className="pt-2">
                            <b>Acute Pulmonary Edema</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7196.png"
                            alt="Accelerated Hypertension"
                          />
                          <p className="pt-2">
                            <b>Accelerated Hypertension</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7197.png"
                            alt="Trauma"
                          />
                          <p className="pt-2">
                            <b>Trauma</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7198.png"
                            alt="Respiratory Failure"
                          />
                          <p className="pt-2">
                            <b>Respiratory Failure</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7199.png"
                            alt="Acute Abdomen"
                          />
                          <p className="pt-2">
                            <b>Acute Abdomen</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7204.png"
                            alt="Myocardial Infarction"
                          />
                          <p className="pt-2">
                            <b>Myocardial Infarction</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7203.png"
                            alt="Poisonings"
                          />
                          <p className="pt-2">
                            <b>Poisonings</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7202.png"
                            alt="Sepsis"
                          />
                          <p className="pt-2">
                            <b>Sepsis</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tabs-padding">
                    <div className="row p-0 justify-content-center">
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7201.png"
                            alt="Stroke"
                          />
                          <p className="pt-2">
                            <b>Stroke</b>
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 pt-4">
                        <div className="SpecialistTab">
                          <StaticImage
                            src="../../../assets/images/kmc-images/Tabs/Emergency_Services/Group7200.png"
                            alt="Anaphylaxis"
                          />
                          <p className="pt-2">
                            <b>Anaphylaxis</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

ContextAwareToggle.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  eventKey: PropTypes.objectOf(PropTypes.any).isRequired,
  callback: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default TabsBlock;
